import React from "react";
import { Helmet } from "react-helmet-async";
import { useGlobal } from "reactn";
import ClassSpecHeader from "../Common/ClassSpecHeader";
import BuildsTabNav from "../FilterManager/BuildsTabNav";
import FilterManager from "../FilterManager/FilterManager";
import { getFormattedNames } from "../../lib/wowHelpers";
import SideAdsContainer from "components/SideAdsContainer";
import Banner from "components/Common/Banner";

const Layout = (props) => {
  const { children, className, classType, filterPage, metaTitle, pageDescription, pageTitle, specType } = props;
  const [windowBreakpoint] = useGlobal("responsive");

  const isMobile =
    windowBreakpoint === "MOBILE_SMALL" || windowBreakpoint === "MOBILE_MEDIUM" || windowBreakpoint === "MOBILE_LARGE";
  const { displayClassName, displaySpecName } = getFormattedNames(classType, specType);

  return (
    <div className={`wow-layout-container ${className}`}>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>
      {/* <Banner /> */}
      <div className="wow-base-content">
        <div
          className="wow-content"
          style={{
            backgroundImage: `url("https://static.bigbrain.gg/wow/background-images/specs/${classType}_${specType}-bg.jpg")`,
          }}
        >
          <ClassSpecHeader
            classType={classType}
            description={pageDescription}
            displayClassName={displayClassName}
            displaySpecName={displaySpecName}
            specType={specType}
            title={pageTitle}
          />
          <BuildsTabNav />
          <FilterManager page={filterPage} isMobile={isMobile} />
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
